import { Store } from 'react-notifications-component';
import Notifications from '../notifications';
import LocalStorage from './LocalStorageService';
import SessionStorage from './SessionStorageService';

class NotificationsService {
  static triggerOfflineNotification = () => {
    return Store.addNotification(Notifications.offline());
  };

  static removeNotification = (id) => {
    Store.removeNotification(id);
  };

  static triggerAppUpdatesNotification = (updateNotificationStatus) => {
    if (updateNotificationStatus === 'visible') {
      LocalStorage.toggleUpdateNotification();
      return Store.addNotification(Notifications.appUpdates());
    }
  };

  static triggerAnnouncementNotification = (announcementNotificationStatus) => {
    if (announcementNotificationStatus !== 'seen') {
      SessionStorage.setSeenAnnouncementNotification();
      return Store.addNotification(Notifications.appAnnouncement());
    }
  };

  static triggerErrorNotification = (error, retry) => {
    return Store.addNotification(Notifications.error(error, retry));
  };

  static triggerNotification = (message, variant) => {
    return Store.addNotification(Notifications.show(message, variant));
  };
}

export default NotificationsService;
